import AutoLogin from 'app/pages/login/AutoLogin';
import Sso from 'app/pages/login/Sso';

import { PATH_AUTO_LOGIN, PATH_LOGIN, PATH_SSO_LOGIN } from 'constants/authPaths';
import { PAGE_CODES } from 'constants/pageCodes';

import Login from '../../pages/login/Login';

const routesConfig = {
  settings: {
    layout: {
      config: {
        toolbar: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: PATH_LOGIN,
      component: Login,
      exact: true,
      isGuestOnly: true,
      pageCode: PAGE_CODES.LOGIN,
    },
    {
      path: PATH_SSO_LOGIN,
      component: Sso,
      exact: true,
      isGuestOnly: true,
      pageCode: PAGE_CODES.SSO_LOGIN,
    },
    {
      path: PATH_AUTO_LOGIN,
      component: AutoLogin,
      exact: true,
      isAuthAgnostic: true,
      pageCode: PAGE_CODES.AUTO_LOGIN,
    },
  ],
};

export default routesConfig;
